// extracted by mini-css-extract-plugin
export var wordContainer = "_px-0";